<template>
  <div>
    <el-dialog
      width="76%"
      @close="onClear"
      top="0px"
      v-loading="loading"
      title="添加工作记录"
      :before-close="handleClose"
      :visible.sync="dialogFormVisible"
      append-to-body
    >
      <el-form :model="form" size="mini" ref="ruleForm" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="记录名称"
              prop="NAME"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model="form.NAME"
                maxlength="100"
                placeholder="请输入记录名称"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin:5px 0">
          <el-col :span="8">
            <el-form-item label="记录类型" :label-width="formLabelWidth">
              <el-select v-model="form.RECORDTYPE" placeholder="请选择记录类型">
                <el-option label="工作日志" :value="0"></el-option>
                <el-option label="问询" :value="1"></el-option>
                <el-option label="代办事项" :value="2"></el-option>
                <el-option label="催办" :value="3"></el-option>
                <el-option label="提醒" :value="4"></el-option>
                <!-- <el-option label="会议" :value="5"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="重要级别" :label-width="formLabelWidth">
              <el-rate
                :max="3"
                style="margin-top: 5px;"
                @change="changeDegree"
                v-model="form.DEGREE"
              ></el-rate>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-top: 5px;margin-left: 20px;">
            <el-checkbox v-model="form.IsOpen">公开记录</el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="接收人" :label-width="formLabelWidth">
              <ayb-select-user
                ref="selectAllUser"
                @getValue="getSelectedUserId"
                width="100%"
                setWidth="100%"
                :isRadio="true"
                :idArray="arrUserId"
              ></ayb-select-user>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="截止时间"
              v-show="form.RECORDTYPE == 2"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                v-model="form.ENDTIME"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                ref="overTimeSelector"
                :picker-options="pickerOptions"
                placeholder="选择日期"
                default-time="12:00:00"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="关联任务" :label-width="formLabelWidth">
              <div class="tag-panel">
                <el-button
                  size="small"
                  class="button-new-tag"
                  @click="importOther"
                  >+ 添加</el-button
                >
                <el-tag
                  closable
                  class="task-tag"
                  effect="plain"
                  type="primary"
                  @close="removeRelations"
                  v-for="(item, index) in taskRelations"
                  :key="index"
                  >{{ item.RELATIONNAME }}</el-tag
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="关联工作记录" :label-width="formLabelWidth">
              <div class="tag-panel">
                <!-- <el-button
                  size="small"
                  class="button-new-tag"
                  @click="addOtherRecord"
                  >+ 新建</el-button
                >-->
                <el-button
                  size="small"
                  class="button-new-tag"
                  @click="importOtherRecord"
                  >+ 添加</el-button
                >
                <el-tag
                  closable
                  class="task-tag"
                  effect="plain"
                  type="primary"
                  @close="removeRelations"
                  v-for="(item, index) in recordRelations"
                  :key="index"
                  >{{ item.RELATIONNAME }}</el-tag
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="el-form-item__label" style="width: 100px;">
              内容描述
              <br />
              <br />
              <el-button
                class="myBtn"
                size="small"
                icon="el-icon-download"
                type="success"
                plain
                @click="$refs.knowledgeDialog.knowledgeDialogVisible = true"
                >知识条目</el-button
              >
              <br />
              <br />
              <el-button
                class="myBtn"
                size="small"
                icon="el-icon-download"
                type="success"
                plain
                @click="$refs.workDialog.workDialogVisible = true"
                >工作记录</el-button
              >
            </div>
            <div class="el-form-item__content" style="margin-left: 100px;">
              <ayb-vueUpload
                :fileList="fileViewList"
                @getValue="fileGetValue"
                @delValue="fileDelValue"
                ref="vueUpload"
              >
                <ayb-uploaderDrop>
                  <wangeditor
                    ref="recordEditor"
                    v-model="form.WorkContent"
                    @uploader="uploader"
                    :isClear="isClear"
                  ></wangeditor>
                  <el-row type="flex">
                    <el-col :span="12">
                      <el-button
                        size="mini"
                        @click="captureStart"
                        style="margin-right:10px"
                        type="primary"
                        >截图</el-button
                      >
                      <el-checkbox size="mini" v-model="hideWindow"
                        >隐藏当前窗口</el-checkbox
                      >
                    </el-col>
                    <el-col
                      :span="12"
                      style="display:flex;align-items: baseline;margin-top:5px"
                    >
                      <el-button
                        @click="upload"
                        class="el-button--mini"
                        type="warning"
                        >上传附件</el-button
                      >
                    </el-col>
                  </el-row>
                </ayb-uploaderDrop>
              </ayb-vueUpload>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="isDisabled" @click="onSubmit"
          >确 定</el-button
        >
        <el-button type="danger" @click="dialogFormVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <taskDialog ref="taskRelationDialog" @getValue="getTask"></taskDialog>
    <knowledgeDialog
      ref="knowledgeDialog"
      @getValue="getKnowledge"
    ></knowledgeDialog>

    <recordSelectDialog
      :outDialogVisible.sync="recordDialogVisible"
      @getSelectedResult="getSelectedResult"
    ></recordSelectDialog>
    <workDialog ref="workDialog" @getValue="getWork"></workDialog>
    <div v-if="otherDialogVisible">
      <SideTagsRecordDialog
        ref="recordDialog"
        @successed="getSelectedResult"
      ></SideTagsRecordDialog>
    </div>
  </div>
</template>

<script>
import cap from "@/capturn/capturnwrapper.js";
import knowledgeDialog from "./knowledgeDialog.vue";
import workDialog from "./workDialog.vue";
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
import fileListView from "@/components/common/fileListView.vue";
import { getToken } from "@/util/auth";
import { regular } from "@/api/modules/basicData/location";
import { Linq, S, DateFormat, TimeFormat } from "@/util/common";
import wangeditor from "@/components/common/editor";
import {
  MergeFile,
  GetRecordInfoByMainId,
  AddOrUpdateRecordInfo,
  GetFileInfoByTaskId,
  DelAttachFile
} from "@/api/modules/basicData/task";

const cookieUser = getToken();
export default {
  name: "SideTagsRecordDialog",
  components: {
    knowledgeDialog,
    workDialog,
    wangeditor,
    fileListView,
    taskDialog: () =>
      import("@/components/basicTemplate/common/taskDialog.vue"),
    recordSelectDialog: () =>
      import("@/views/task/Record/SelectRecordDialog.vue"),
  },
  computed: {
    recordRelations() {
      return this.form.Relations != null
        ? this.form.Relations.filter(o => o.RELATIONTYPE == 2)
        : [];
    },
    taskRelations() {
      return this.form.Relations != null
        ? this.form.Relations.filter(o => o.RELATIONTYPE == 0)
        : [];
    },
    isRadio() {
      return this.form.RECORDTYPE == 2; //   0工作记录, 1问询, 2小事务,3催办,4提醒, 5会议记录
    }
  },
  props: ["pageType", "task"],
  watch: {
    task(newValue) {
      if (newValue) {
        console.log("record->task", newValue);
        this.getTask([newValue]);
      }
    }
  },
  data() {
    var checknum = (rule, value, callback) => {
      value = this.trim(value);
      if (!value) {
        callback(new Error("不能为空"));
        this.time("ruleForm", "NAME");
      } else {
        callback();
      }
    };
    return {
      uid: "",
      hideWindow: true, // 是否隐藏当前窗口
      fileViewList: [],
      filePathList: [],
      delFilePathList: [],
      otherDialogVisible: false,
      recordDialogVisible: false,
      form: {
        NAME: "",
        RECORDTYPE: 0,
        IsOpen: true,
        WorkContent: "",
        ENDTIME: "",
        DEGREE: 0,
        Members: [], //接收人
        Relations: [] //工作记录关联 根据relationtype区分 0为任务 1是作业计划 2是工作记录
      },
      arrUserId: [],
      degree: 0,
      loading: false,
      fdata: {
        guid: this.Guid()
      },
      isClear: true,
      isDisabled: false,
      type: 0,
      recordId: this.Guid(),
      type1: this.$route.query.type || 2,
      // mainId: "",
      // mainType: 0,
      // mainInstance: "",
      RecordList: {},
      dialogFormVisible: false,
      checked: true,
      formLabelWidth: "120px",
      TaskInstance: "",
      BelongUser: "",
      TaskName: "",
      Quotes: [], //任务引用
      isEdit: false,
      filePanelHeight: 0,
      fileList: [],
      existFileList: [],
      deletedFileList: [],
      rules: {
        NAME: [
          {
            validator: checknum,
            trigger: "blur"
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  methods: {
    addOtherRecord() {
      this.otherDialogVisible = true;
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.recordDialog.dialogFormVisible = true;
        this.$refs.recordDialog.type = 0;
      });
    },
    captureStart() {
      // 截图开始
      cap.StartCapture(this.hideWindow, this);
    },
    upload() {
      this.$refs.vueUpload.openUploader({
        // id: "1111" // 传入的参数
      });
    },
    uploader(files) {
      this.$refs.vueUpload.onFileAdded(files[0]);
    },
    fileGetValue(fileList) {
      //上传成功的文件
      this.filePathList = fileList;
    },
    fileDelValue(fileList) {
      //删除的文件
      this.delFilePathList = fileList;
    },
    getKnowledge(content) {
      this.$refs.recordEditor.setContent(this.form.WorkContent + content);
    },
    getWork(content) {
      this.$refs.recordEditor.setContent(this.form.WorkContent + content);
    },
    changeDegree(val) {
      if (val == this.degree && val != 0) {
        this.form.DEGREE = 0;
        this.degree = 0;
      } else {
        this.degree = val;
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    fileChange(file) {
      if (!file.size) return;
      this.fileList.push(file);
      this.filePanelHeight = {
        height: (this.fileList.length + 1) * 50 + "px"
      };
      console.log("filePanelHeight", this.filePanelHeight);
    },
    resume(file) {
      this.uploader.upload(file);
    },
    stop(file) {
      this.uploader.stop(file);
    },
    remove(file) {
      // 取消并中断文件上传
      this.uploader.cancelFile(file);
      // 在队列中移除文件
      this.uploader.removeFile(file, true);

      // 在ui上移除
      let index = this.fileList.findIndex(ele => ele.id === file.id);
      this.fileList.splice(index, 1);
      this.filePanelHeight = {
        height: (this.fileList.length + 1) * 50 + "px"
      };
      console.log("filePanelHeight", this.filePanelHeight);
    },
    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    fileCategory(ext) {
      let type = "";
      const typeMap = {
        image: ["gif", "jpg", "jpeg", "png", "bmp", "webp"],
        video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
        text: [
          "doc",
          "txt",
          "docx",
          "pages",
          "epub",
          "pdf",
          "numbers",
          "csv",
          "xls",
          "xlsx",
          "keynote",
          "ppt",
          "pptx"
        ]
      };
      Object.keys(typeMap).forEach(_type => {
        const extensions = typeMap[_type];
        if (extensions.indexOf(ext) > -1) {
          type = _type;
        }
      });
      return type;
    },
    onProgress(file, percent) {
      $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
      $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + "%");
    },
    fileUploadCompleted(file, response) {
      console.log(response);
      console.log(response.guid);
      MergeFile(response.guid, response.f_ext).then(data => {
        console.log("合并：", data);
        if (data) {
          this.filePathList.push(data);
        } else {
          this.$message.error("文件合并失败！");
        }
      });
    },
    onFileDelete(id) {
      this.deletedFileList.push(id);
    },
    removeRelations(val) {
      this.form.Relations.splice(this.form.Relations.indexOf(val), 1);
    },
    editRecord(val) {
      console.log("editRecord", val);
      this.dialogFormVisible = true;
      this._getRecord(val);
    },
    _getRecord(val) {
      console.log("_getRecord", val);
      this.loading = true;
      this.recordId = val.ID;
      this.isEdit = true;
      this.degree = val.DEGREE;
      this.form = {
        NAME: val.NAME,
        RECORDTYPE: val.RECORDTYPE,
        IsOpen: val.ISOPEN,
        DEGREE: val.DEGREE,
        ENDTIME: val.ENDTIME,
        Members: val.Members,
        Relations: val.Relations
      };
      this.$nextTick(() => {
        this.$refs.recordEditor.setContent(val.INFO);
      });
      if (val.Members) {
        this.arrUserId = val.Members.map(o => o.USERID);
        console.log("arrUserId", this.arrUserId);
      }
      GetFileInfoByTaskId(val.ID, 5)
        .then(res => {
          console.log("文件列表：", res);
          res.forEach(c => {
            c._id = c.ID;
            c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
          });
          this.existFileList = res;
          this.fileViewList = res;
          this.loading = false;
        })
        .catch(err => {
          console.log("文件列表获取失败！");
          this.loading = false;
        });
    },
    getTask(arr) {
      if (arr.length > 0) {
        console.log("getTask", arr);
        let newRelations = arr
          .filter(val => {
            console.log(
              this.form.Relations.map(r => r.RELATIONID).indexOf(val.ID)
            );
            return (
              this.form.Relations.map(r => r.RELATIONID).indexOf(val.ID) === -1
            );
          })
          .map(item => {
            return {
              RELATIONID: item.ID,
              RECORDID: this.recordId,
              RELATIONTYPE: 0,
              RELATIONUSERNAME:
                item.EXCUTEUSERNAME == ""
                  ? item.SERVERCENTERNAME
                  : item.EXCUTEUSERNAME,
              RELATIONINSTANCE: item.INSTANCE,
              RELATIONNAME: item.TASKNAME
            };
          });
        if (newRelations)
          this.form.Relations = this.form.Relations.concat(newRelations);
        console.log(this.form.Relations);
      }
    },
    //导入任务
    importOther() {
      this.$refs.taskRelationDialog.dialogVisible = true;
    },
    importOtherRecord() {
      this.recordDialogVisible = true;
    },
    getSelectedResult(val) {
      var array = [];
      if (val instanceof Array) array = val;
      else array.push(val);
      this.recordDialogVisible = false;

      console.log("getSelectedResult start", array);
      array.forEach(item => {
        if (this.form.Relations.some(o => o.RELATIONID == item.ID) == false)
          this.form.Relations.push({
            RELATIONID: item.ID,
            RECORDID: this.recordId,
            RELATIONTYPE: 2,
            RELATIONUSERNAME: item.Members.map(o => o.USERNAME).join(","),
            RELATIONINSTANCE: item.INSTANCE,
            RELATIONNAME: item.NAME
          });
      });

      console.log("getSelectResult end");
    },
    addRecordRelation(id, name, type, instance) {
      if (this.form.Relations.some(o => o.RELATIONID == id) == false)
        this.form.Relations.push({
          RELATIONID: id,
          RECORDID: this.recordId,
          RELATIONTYPE: type,
          RELATIONUSERNAME: cookieUser.realName,
          RELATIONINSTANCE: instance,
          RELATIONNAME: name
        });
    },
    getSelectedUserId(val) {
      if (val.length > 0) {
        console.log(val);
        this.form.Members = val.map(item => {
          return {
            RECORDID: this.recordId,
            USERID: item.UserId,
            USERNAME: item.Name,
            DEPTID: item.DeptId,
            DEPTNAME: item.DeptName,
            COMPANYID: item.CompanyId,
            COMPANYNAME: item.CompanyName
          };
        });
      }
    },
    //引入任务
    importTask(list) {
      if (!list) return;
      list.forEach(otherTask => {
        this.$refs.wandEditor.setAppendContent(
          `<a style="color:#409EFF" href="${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/task-detailspage?taskid=${
            otherTask.ID
          }" target="_Blank">任务引用：${otherTask.TASKNAME}</a><br/>`
        );
        this.Quotes.push({
          name: otherTask.TASKNAME,
          id: otherTask.ID,
          instance: otherTask.INSTANCE,
          value: `<a style="color:#409EFF" href="${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/task-detailspage?taskid=${otherTask.ID}" target="_Blank">`
        });
      });
    },
    /**添加工作记录提交 */
    onSubmit() {
      if (!this.isDisabled) {
        if (this.form.RECORDTYPE > 0) {
          if (this.form.Members.length == 0) {
            this.$message.warning("请选择接收人");
            return;
          }
        }
        this.isDisabled = true;
        this.$refs["ruleForm"].validate(valid => {
          this.loading = true;
          if (valid) {
            const user = getToken();
            const date = new Date();
            console.log("getContent", this.$refs.recordEditor.getContent());
            let parasInfo = {
              // 注意： 运维人员列表里 并没有人员的机构，所以在归属人的机构处理了一下
              ID: this.recordId,
              INFO: this.$refs.recordEditor.getContent(),
              CREATEUSERID: user.userId,
              CREATEUSERNAME: user.realName,
              CREATEDEPTID: user.departmentId,
              CREATEDEPTNAME: user.departmentName,
              ENABLE: true,
              CREATECOMPANYID: user.organizationId,
              CREATECOMPANYNAME: "",
              CREATETIME: date,
              NAME: this.form.NAME,
              ISOPEN: this.form.IsOpen,
              DEGREE: this.form.DEGREE,
              RECORDTYPE: this.form.RECORDTYPE,
              STATE: 0,
              ENDTIME: this.form.ENDTIME,
              Relations: this.form.Relations,
              Members: this.form.Members
            };

            AddOrUpdateRecordInfo(parasInfo, this.filePathList, this.isEdit)
              .then(result => {
                this.loading = false;
                if (result === 1) {
                  // this.initalTask();
                  DelAttachFile(this.deletedFileList.join(",")).then(res => {
                    console.log(res);
                  });
                  this.dialogFormVisible = false;
                  this.$message({
                    type: "success",
                    message: this.isEdit
                      ? "编辑工作记录成功"
                      : "添加工作记录成功。"
                  });

                  if (this.type === 0) {
                    console.log("pageType", this.pageType);
                    if (this.pageType == "2") {
                      this.$parent.initalTask();
                    } else {
                      this.$emit("successed", parasInfo);
                      // this.$parent.initalTask();
                    }
                  }
                  if (this.type1 === "3") {
                    this.$store.dispatch("GetTaskGroupTaskList");
                  }

                  this.onClear();
                } else {
                  this.$message({
                    type: "error",
                    message: this.isEdit
                      ? "编辑工作记录失败"
                      : "添加工作记录失败！"
                  });
                }
                this.loading = false;
                this.isDisabled = false;
              })
              .catch(ex => {
                this.$message({
                  type: "error",
                  message: "添加工作记录失败！"
                });
                this.isDisabled = false;
                console.log(ex);
              });
          } else {
            this.isDisabled = false;
            this.loading = false;
          }
        });
      }
    },
    onClear() {
      console.log("onClear");
      this.$refs["ruleForm"].resetFields();
      this.form = {
        NAME: "",
        RECORDTYPE: 0,
        IsOpen: true,
        DEGREE: 0,
        ENDTIME: "",
        WorkContent: "",
        Members: [],
        Relations: []
      };
      this.isEdit = false;
      this.$refs.recordEditor.reset();
      this.$refs.selectAllUser.reset();
      this.$refs.vueUpload.close();
      this.recordId = this.Guid();
      this.fileList = [];

      this.filePanelHeight = {
        height: 0
      };
      this.existFileList = [];
      this.fileViewList = [];
      this.deletedFileList = [];
    }
  },
  created() {
    cap.Init(this); //初始化截图插件。
  }
};
</script>

<style lang="scss" scoped>
.tag-panel {
  // margin-left: 120px;
  // margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.task-tag {
  margin-top: 5px;
  margin-right: 10px;
}

.button-new-tag {
  margin-top: 5px;
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.grid-content .el-row {
  padding: 5px 20px 0 20px;
}

.el-col {
  border-radius: 4px;
  text-align: left;
}

.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}

.button {
  margin: 20px 0 0 20px;
  float: left;
}

.bg-purple-dark {
  background: white;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.Details {
  background-color: #f3f3f3;
  min-height: 500px;
}

.title {
  text-align: left;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #0099ff;
}

.abstract {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #606266;
}

.tagtitle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}

.importBtn {
  margin: 1px 2px 5px 1px !important;
}

.file-panel {
  margin-left: 120px;
  max-width: 840px;
  margin-top: 10px;
  box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.1);

  > h2 {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
  }

  .file-list {
    position: relative;
    overflow-y: auto;
    background-color: rgb(250, 250, 250);
  }

  .file-item {
    position: relative;
    line-height: 50px;
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    z-index: 1;

    > li {
      display: inline-block;
    }
  }

  .file-type {
    width: 24px;
    height: 24px;
    vertical-align: -5px;
  }

  .file-name {
    width: 40%;
    margin-left: 10px;
  }

  .file-size {
    width: 20%;
  }

  .file-status {
    width: 20%;
  }

  .file-operate {
    width: 10%;

    > a {
      padding: 10px 5px;
      cursor: pointer;
      color: #666;

      &:hover {
        color: #ff4081;
      }
    }
  }

  .file-type[icon="text"] {
    background: url(../../../assets/img/icon/text-icon.png);
  }

  .file-type[icon="video"] {
    background: url(../../../assets/img/icon/video-icon.png);
  }

  .file-type[icon="image"] {
    background: url(../../../assets/img/icon/image-icon.png);
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    width: 0;
    background-color: #e2edfe;
    z-index: -1;
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }
}
</style>
